/**
 * SahneOzmoKafa - FikoYT Ozmo Kafa sahne sınıfı
 * Ported from old system to new dialog-based architecture
 */

import * as THREE from 'three';
import { degToRad } from 'three/src/math/MathUtils';
import { UstAciOzmo } from './UstAciOzmo';
import { AltAciOzmo } from './AltAciOzmo';
import { FikoSahne } from '../../IFikoThreeJS/FikoSahne';
import { FikoCizimler } from '../../IFikoThreeJS/FikoThreeCam/FikoCizimler';
import { FikoKaynakca } from '../../IFikoThreeJS/FikoThreeCam/FikoKaynakca';
import { FikoIsiklar } from '../../IFikoThreeJS/FikoIsiklar';
import { FikoIsikOrtam } from '../../IFikoThreeJS/FikoIsikOrtam';
import { FikoEksen } from '../../IFikoThreeJS/FikoEksen';
import { FikoTakimFrezeleme } from '../../IFikoThreeJS/FikoThreeCam/FikoTakimFrezeleme';
import { FikoVektor3D } from '../../IFikoThreeJS/FikoVektor3d';
import { FikoThreeJsComponent } from '../../fiko-three-js.component';

export class SahneOzmoKafa extends FikoSahne {
  /** Standart gruplar */
  cizimler: FikoCizimler;
  kaynakca: FikoKaynakca;
  kaynakcaIsiklar: FikoIsiklar;

  /** Açı kontrolleri */
  BAcisi: UstAciOzmo;
  CAcisi: AltAciOzmo;
  takim: FikoTakimFrezeleme;

  constructor(public override anaGosterim: FikoThreeJsComponent) {
    super(anaGosterim);

    // Çizimler grubu
    this.cizimler = new FikoCizimler(this, "Ozmo Kafa");

    // Eksen
    let eksen = new FikoEksen(this, "Eksen.1");
    this.cizimler.ekle(eksen);

    // Üst açı (B Açısı)
    this.BAcisi = new UstAciOzmo(this, "Üst.1");

    // Alt açı (C Açısı)
    this.CAcisi = new AltAciOzmo(this, "Alt.1");
    this.BAcisi.ekle(this.CAcisi);

    this.cizimler.ekle(this.BAcisi);

    // Takım (frezeleme)
    this.takim = new FikoTakimFrezeleme(this, 3, 1.5, 30, 15);

    var myDirectionVector = new FikoVektor3D(0, 0, 1);
    var mx = new THREE.Matrix4().lookAt(myDirectionVector, new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, 0, 1));
    var qt = new THREE.Quaternion().setFromRotationMatrix(mx);
    this.takim.quaternion.copy(qt);

    this.cizimler.ekle(this.takim);

    // Takım ekseni
    let eksenTakim = new FikoEksen(this, "Eksen.Takim");
    eksenTakim.position.set(0, 0, -((203.8 + this.CAcisi.takim.boy)));
    this.cizimler.ekle(eksenTakim);

    // Kaynakça grubu
    this.kaynakca = new FikoKaynakca(this, "FikoYT Kaynakça");

    // Işıklandırma
    this.kaynakcaIsiklar = new FikoIsiklar(this, "Fiko Işıklar");
    let anaOrtamIsigi = new FikoIsikOrtam(this, "Fiko Ana Ortam Işığı.1");
    anaOrtamIsigi.intensity = 0.5;
    this.kaynakcaIsiklar.ekle(anaOrtamIsigi);

    this.kaynakca.ekle(this.kaynakcaIsiklar);

    // Sahneye ekle
    this.add(this.cizimler);
    this.add(this.kaynakca);

    // Kamera konumları - yeni veri formatı
    this.kaynakca.konumlar.kaydet("Fikonum.1", "Ozmo Kafa Görünümü", {
      position: [-54.62522518603117, -136.2241883547141, -110.99939777780367],
      quaternion: [0.6115634792345813, -0.13987621165123368, -0.1533193529158464, 0.7634906235848999],
      ust: [0.3588887431892337, 0.8360886477691265, 0.4149152239718947],
      hedef: [-20.959900596030632, -61.447393292844616, -128.86361453995406],
      yakinlik: 0.40826723593892267,
      oran: 1
    });
  }

  /**
   * PERFORMANS: Ekrana sığdır - optimized version
   */
  override ekranaSigdir(sahne: any): void {
    if (!this.anaGosterim?.aktifKamera || !this.cizimler) return;

    const box = new THREE.Box3().setFromObject(this.cizimler);
    const size = box.getSize(new THREE.Vector3());
    const center = box.getCenter(new THREE.Vector3());

    const maxDim = Math.max(size.x, size.y, size.z);
    const fov = this.anaGosterim.aktifKamera.fov * (Math.PI / 180);
    let cameraZ = Math.abs(maxDim / 2 / Math.tan(fov / 2));

    cameraZ *= 1.5; // Zoom out biraz

    this.anaGosterim.aktifKamera.position.set(center.x, center.y, center.z + cameraZ);
    this.anaGosterim.aktifKamera.lookAt(center);
    this.anaGosterim.aktifKamera.updateProjectionMatrix();
    this.anaGosterim.ciz();
  }
}
